// Admin login is checked by the backend (/api/admin/*). No credentials live in
// frontend code. The session is an HttpOnly cookie the browser sends automatically;
// sessionStorage only keeps a UI hint so the login page can skip ahead.
import { API_BASE } from "../../services/apiClient";

const ADMIN_AUTH_KEY = "mng-admin-auth";

function setHint(on) {
  try {
    if (on) window.sessionStorage.setItem(ADMIN_AUTH_KEY, "1");
    else window.sessionStorage.removeItem(ADMIN_AUTH_KEY);
  } catch { /* storage blocked — the server cookie is what matters */ }
}

export function isAdminLoggedIn() {
  try {
    return window.sessionStorage.getItem(ADMIN_AUTH_KEY) === "1";
  } catch {
    return false;
  }
}

// Ask the server whether this browser has a valid admin session.
export async function checkAdminSession() {
  try {
    const res = await fetch(`${API_BASE}/api/admin/me`, { credentials: "include", cache: "no-store" });
    const data = await res.json().catch(() => ({}));
    const ok = Boolean(res.ok && data.loggedIn);
    setHint(ok);
    return ok;
  } catch {
    setHint(false);
    return false;
  }
}

// Returns { ok: true } or { ok: false, message }
export async function loginAdmin(username, password) {
  try {
    const res = await fetch(`${API_BASE}/api/admin/login`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: String(username || "").trim(), password: String(password || "") }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
      return { ok: false, message: data.message || `เข้าสู่ระบบไม่สำเร็จ (HTTP ${res.status})` };
    }
    setHint(true);
    return { ok: true };
  } catch {
    return { ok: false, message: "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ กรุณาลองใหม่" };
  }
}

export function logoutAdmin() {
  setHint(false);
  return fetch(`${API_BASE}/api/admin/logout`, { method: "POST", credentials: "include" }).catch(() => {});
}
